import { render, staticRenderFns } from "./ResultPhoneHistoryComponent.vue?vue&type=template&id=226acb00"
import script from "./ResultPhoneHistoryComponent.vue?vue&type=script&lang=js"
export * from "./ResultPhoneHistoryComponent.vue?vue&type=script&lang=js"
import style0 from "./ResultPhoneHistoryComponent.vue?vue&type=style&index=0&id=226acb00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports